import { render } from "./BaseSpinner.vue?vue&type=template&id=06389a32&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=06389a32&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-06389a32"

export default script